export const getProjectsAPI = "/distinguished-projects";
export const getProjectsTagsAPI = "/programs-titles";
export function getProjectAPI(id) {
  return "/distinguished-projects/" + id;
}
